import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { getAppConfig } from '../../app.config';
import { AuthService } from '../../shared/services/auth.service';
import { AUTH_REDIRECT_PARAM } from '../interceptors/types-interfaces-enums';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    private readonly externalLoginUrl: string | undefined;

    constructor(private router: Router, private authService: AuthService) {
        this.externalLoginUrl = getAppConfig().loginUrl;
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.checkAuthenticatedStatus().pipe(
            tap(authenticated => {
                if (!authenticated) {
                    if (this.externalLoginUrl) {
                        window.location.href = this.externalLoginUrl;
                    } else {
                        // Preserve the current URL for redirect after login
                        this.router.navigate(['/login'], {
                            queryParams: {
                                [AUTH_REDIRECT_PARAM]: btoa(state.url),
                            },
                        });
                    }
                }
            }),
        );
    }
}